import axios from "axios";
import {doc, getDoc} from "firebase/firestore";
import {db} from "../firebase";

const mapsApiUrl = 'https://taucarpool.herokuapp.com/taucarpoolalgo';
const tauCoordinates = {
    "Longitude": 32.113800746333716,
    "Latitude": 34.80417879757766
};

export async function getMapForRide(rideId) {
    const rideDoc = await getDoc(doc(db, "geo-rides", rideId));
    const rideData = rideDoc.data();
    const midpointsArray = rideData.riders_locations.map(xyObject => ({
        "Longitude": xyObject.x,
        "Latitude": xyObject.y
    }));
    const startCoordinates = {
        "Longitude": rideData.coordinate_x,
        "Latitude": rideData.coordinate_y
    };
    const finalJsonRequestBody = {
       "start": startCoordinates,
       "end": tauCoordinates,
       "midpoints": midpointsArray
    };

    console.log(`sending request to maps API...`)
    const response = await axios.post(mapsApiUrl, finalJsonRequestBody);
    console.log(`received response from API, status: ${response.status}`);
    const mapHtml = response.data.result;
    return mapHtml;
}